import type { AxiosResponse } from "axios";

import { baseRoutes } from "@/api/base-routes";
import { packNetAxios } from "@/lib/api-client";
import type {
	CreateProductionGroup,
	DeleteProductionGroup,
	ProductionGroup,
	UpdateProductionGroup,
} from "@/schemas/production-group";

export type { CreateProductionGroup, UpdateProductionGroup };

const selectionApi = `${baseRoutes.selection}/v1/ProductionGroups`;

type ProductionGroupAliasResponse = {
	productionGroupAlias: string;
};

export async function getProductionGroups(): Promise<ProductionGroup[]> {
	const response = await packNetAxios.get<ProductionGroup[]>(selectionApi);
	return response.data;
}

export async function createProductionGroup(data: CreateProductionGroup): Promise<ProductionGroup[]> {
	const response = await packNetAxios.post<ProductionGroup[]>(selectionApi, data);
	return response.data;
}

export async function updateProductionGroup(data: UpdateProductionGroup): Promise<ProductionGroup[]> {
	const response = await packNetAxios.put<ProductionGroup[]>(`${selectionApi}/${data.id}`, data);
	return response.data;
}

export async function deleteProductionGroup(id: string): Promise<DeleteProductionGroup> {
	const response = await packNetAxios.delete<DeleteProductionGroup>(`${selectionApi}/${id}`);
	return response.data;
}

export async function fetchProductionGroupAliasByMachineGroup(machineGroupId: string): Promise<string | undefined> {
	const url = `${selectionApi}/bymachinegroup/${machineGroupId}/alias`;
	const response = await packNetAxios.get<ProductionGroupAliasResponse>(url);

	if (response.status === 200) {
		return response.data.productionGroupAlias;
	}
}

export async function assignMachineGroupToProductionGroup(
	productionGroupId: string,
	machineGroupId: string,
): Promise<AxiosResponse<ProductionGroup>> {
	return packNetAxios.put(`${selectionApi}/${productionGroupId}/machinegroups/${machineGroupId}`, {});
}

export async function removeMachineGroupFromProductionGroup(machineGroupId: string): Promise<AxiosResponse<unknown>> {
	return packNetAxios.put(`${selectionApi}/RemoveMachineGroupFromProductionGroup/${machineGroupId}`, {});
}
